import {
  GET_REVENUE_LIST,
  GET_REVENUE_LIST_SUCCESS,
  GET_REVENUE_LIST_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getRevenueListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REVENUE_LIST:
      return { ...state, loading: true };
    case GET_REVENUE_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_REVENUE_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getRevenueListReducer;
